<template>
  <v-app :class="{ mainBackGround: isShowSidebarHeader }">
    <!-- loading -->
    <div v-if="$store.state.Common.isLoading > 0" class="loading-img-wrap">
      <div class="loading-img">
        <Loader />
      </div>
    </div>
    <div v-if="isShowSidebarHeader">
      <Header />
      <Sidebar />
    </div>
    <v-main :class="{ isRegisterPage }">
      <router-view />
    </v-main>
  </v-app>
</template>
<script>
import Header from '@/components/layouts/Header/Header'
import Sidebar from '@/components/layouts/Sidebar/Sidebar'
import Loader from '@/components/Loader'
import { mapGetters, mapActions } from 'vuex'
import { commonUtil } from '@/util'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    Header,
    Sidebar,
    Loader
  },
  computed: {
    isShowSidebarHeader() {
      // もっとヘッダー、サイドバーを非表示にする対象が増えるならコンフィグに対象ルート抜き出すとか対応
      if (
        this.$route.name == 'Login' ||
        this.$route.name == 'contact' ||
        this.$route.name == 'contact.success' ||
        this.$route.name == 'user.register' ||
        this.$route.name == 'mail-verify' ||
        this.$route.name == 'user.profile' ||
        this.$route.name == 'user.register.success' ||
        this.$route.name == 'user.password-reset-mail' ||
        this.$route.name == 'user.password-reset-mail.success' ||
        this.$route.name == 'reset-password' ||
        this.$route.name == 'reset-password.success' ||
        this.$route.name == 'maintenance' ||
        this.$route.name == 'nextengine-cooperate'
      ) {
        return false
      }
      return true
    },
    isRegisterPage() {
      return this.$route.name === 'user.register'
    }
  },
  methods: {
    ...mapGetters('Common', ['getLangFromState']),
    ...mapActions('Common', ['resetIsLoading'])
  },
  created() {
    this.resetIsLoading()
    this.$i18n.locale = this.getLangFromState()
    axios.defaults.params = { lang: this.$i18n.locale }

    // マスタデータ一括取得
    commonUtil.bulkGetMasterData()
  }
}
</script>
<style lang="scss">
@import '@/styles/index.scss';
html {
  overflow: auto !important;
}

.v-main {
  background-color: #f6f6f6;
  &.isRegisterPage {
    background-color: #fff;
  }
}

.mainBackGround {
  min-width: 1400px;
}
.loading-img {
  z-index: inherit;
  transform: translate(-50%, -50%);
  position: fixed;
  top: 50vh;
  left: 50vw;
}
.loading-img-wrap {
  z-index: 300;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.5);
}
</style>
